import Image from "next/image";
import Link from "next/link";

import { HiArrowRight } from "react-icons/hi";

import CasinoGames from "@/features/v2/home/components/CasinoSection/components/CasinoGames";
import { CasinoSectionProps } from "@/features/v2/home/components/CasinoSection/interface";
import core from "@/features/v2/home/components/localization/core";

import { CasinoSectionType } from "./enums";

const image = {
  casino: "/img/v2/icons/card.webp",
  zinga: "/img/v2/icons/diamond.webp",
  favorites: "/img/v2/icons/star.webp"
};

const CasinoSection = ({ type = CasinoSectionType.CASINO, showLink = true, instanceId, initialGames }: CasinoSectionProps) => {
  return (
    <section className="flex flex-col gap-4 ms-4 mt-6 md:mt-10 md:mx-auto md:max-w-8xl " aria-label="Juegos de Casino">
      <header className="flex justify-between items-center me-4 z-10">
        <div className="flex items-center gap-2">
          <Image src={image[type]} alt="Icono de cartas de casino" width={30} height={30} className="h-[30px] w-[30px] object-contain" loading="lazy" quality={70} />
          <h2 className="text-base font-bold text-white">{core.public.casino.title[type]}</h2>
        </div>
        {showLink && (
          <Link prefetch className="flex items-center gap-1 border-b-2 border-primary-400 leading-none" href={core.public.casino.link} aria-label={`Ver más ${core.public.casino.title[type]}`}>
            <p className="text-sm font-bold font-text bg-gradient-to-t from-primary-800 to-primary-600 text-transparent bg-clip-text">{core.public.casino.textLink}</p>
            <HiArrowRight className="text-sm font-bold text-primary-600" />
          </Link>
        )}
      </header>

      <CasinoGames type={type} instanceId={instanceId} initialGames={initialGames} />
    </section>
  );
};

export default CasinoSection;
